
export default {
  namespaced: true,
  state: {
    isLoading: false
  },
  getters: {
    sideMenuActive: () => {

    }
  },
  mutations: {
    setLoading(state, value) {
      state.isLoading = value;
    }
  },
  actions: {
    setLoading({commit}, value) {
      commit('setLoading', value);
    },
    isSideMenuActive() {
      return document.getElementsByClassName('sidebar-lg-show header-fixed sidebar-fixed aside-menu-fixed aside-menu-off-canvas aside-menu-lg-show')[0]
         !== undefined;
    },
    async closeSideMenu({dispatch}) {
      const isOpen = await dispatch('isSideMenuActive');
      if (isOpen)
        await dispatch('toogleSideMenu');
    },
    async openSideMenu({dispatch}) {
      const isOpen = await dispatch('isSideMenuActive');
      if (!isOpen)
        await dispatch('toogleSideMenu');
    },
    async toogleSideMenu() {
      document.getElementsByClassName('d-none d-lg-block navbar-toggler')[0].click();
    }
  }
}
